<!--
this just displays the about
https://textkool.com/en/ascii-art-generator
 -big font
-->
<script>

</script>
<style>

#main{
    text-align:center;
    /*font-weight:normal;*/
    width: 500px;
    margin:auto auto;
    font-size:16px;
}

.info{
    margin:40px;
    text-align:justify;
    text-justify: inter-word;
    width:450px;
}

</style>

<div id="main">
    <h3>- About -</h3>
   <pre>
     _       __ _                        _       
    | |     / _| |                      | |      
  __| | ___| |_| |_ ___ ___  _   _  ___ | |_ ___ 
 / _` |/ _ \  _| __/ __/ _ \| | | |/ _ \| __/ _ \
| (_| |  __/ | | || (_| (_) | |_| | (_) | ||  __/
 \__,_|\___|_|  \__\___\___/ \__, |\___/ \__\___|
                              __/ |              
                             |___/                
</pre>
   <p class="info">
   &nbsp; &nbsp; TIS-10 is published by Deft Coyote Games (deftcoyote.com). Copyright Deft Coyote 2024, all rights reserved. The game may not be redistributed in whole or in part by other parties without written consent of the publisher.

   <br/><br/>
   &nbsp; &nbsp; This game is an homage to the TIS-100 game by Zachtronics LLC with the intent to spark more interest in that game, and to have something similar to play on mobile devices.
   </p>
   <p style="text-align:right">
   deftcoyote.com <br/>
   deftcoyote.itch.io
   </p>
</div>